import { create } from "zustand";

interface VideoMeetingState {
  id?: string;
  setId: (id: string) => void;
}

export const useVideoMeetingStore = create<VideoMeetingState>()((set) => ({
  setId: (id) =>
    set((state) => ({
      id: id,
    })),
}));
